import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { initGA, logPageView } from "./analytics";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CompanyDirectory from "./pages/CompanyDirectory";
import JobsBoard from "./pages/JobsBoard";
import Testimonials from "./pages/Testimonials";
import CertificationCenter from "./pages/CertificationCenter";
import HypersensitivityCenter from "./pages/HypersensitivityCenter";
import ProductReviews from "./pages/ProductReviews";
import EmployerDashboard from "./pages/EmployerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PACompanyLanding from "./pages/PACompanyLanding";
import PestIdentificationGuide from "./pages/PestIdentificationGuide";
import LicenseRenewal from "./pages/LicenseRenewal";
import CourseCatalog from "./pages/CourseCatalog";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import BlogsPage from "./pages/BlogsPage";
import BlogDetail from "./pages/BlogDetail";
import SafetyTraining from "./pages/SafetyTraining";
import SafetyModuleDetail from "./pages/SafetyModuleDetail";

function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/companies" element={<CompanyDirectory />} />
            <Route path="/jobs" element={<JobsBoard />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/certifications" element={<CertificationCenter />} />
            <Route path="/hypersensitivity" element={<HypersensitivityCenter />} />
            <Route path="/product-reviews" element={<ProductReviews />} />
            <Route path="/pest-id" element={<PestIdentificationGuide />} />
            <Route path="/license-renewal" element={<LicenseRenewal />} />
            <Route path="/courses" element={<CourseCatalog />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/blogs/:id" element={<BlogDetail />} />
            <Route path="/safety-training" element={<SafetyTraining />} />
            <Route path="/safety-training/:id" element={<SafetyModuleDetail />} />
            <Route path="/pa-companies" element={<PACompanyLanding />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <EmployerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
